import React from "react";
import { useFormContext } from "react-hook-form";
import { FieldErrorMessage } from "../ui/Text";
import { Col } from "../css";

interface Option {
  label: string;
  value: string;
}

interface RadioInputProps {
  label: string;
  field: string;
  disabled?: boolean;
  required?: boolean;
  defaultValue?: string;
  options: Option[];
}

const RadioInput: React.FC<RadioInputProps> = ({ field, required = false, disabled = false, defaultValue = "", options }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const errorMessage: any = errors[field]?.message;

  const getRegisterOptions = () => {
    const registerOptions: any = {};
    if (required) {
      registerOptions.required = "This field is required.";
    }
    return registerOptions;
  };
  // console.log({ required, field });

  return (
    <Col>
      <div className="flex gap-x-3 pt-2 items-center">
        {options.map((option, i) => {
          const { label } = option;
          const uniqueFieldName = field + i;
          return (
            <label className={`${i > 0 ? "pl-2" : ""}  flex items-center gap-x-2`} key={uniqueFieldName} htmlFor={uniqueFieldName}>
              <input
                type="radio"
                id={uniqueFieldName}
                className={`${errors[field]?.message ? "border-red-600" : "border-gray-300"}`}
                {...register(field, {
                  ...getRegisterOptions(),
                })}
                disabled={disabled}
                defaultChecked={defaultValue == option?.label || defaultValue == option?.value}
                value={option.value}
              />
              <span className={`cursor-pointer text-text-default text-13`}>{label}</span>
            </label>
          );
        })}
      </div>
      {errorMessage && <FieldErrorMessage text={errorMessage} />}
    </Col>
  );
};

export default RadioInput;
